<template>
  <v-container fluid>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb-3">
      <el-breadcrumb-item :to="{ path: '/' }">แดชบอร์ด</el-breadcrumb-item>
      <el-breadcrumb-item>ออเดอร์ล่วงหน้า (7 วัน)</el-breadcrumb-item>
    </el-breadcrumb>
    <v-layout row wrap class="mb-2 mx-0">
      <v-flex xs12 sm9 md9>
        <!-- <h3 class="subtitle-1 font-weight-bold">ออเดอร์ของวันที่ {{date}}</h3> -->
        <el-card class="box-card">
          <v-layout wrap>
            <v-flex class="text-xs-center">
              <strong>ยอดขาย</strong>
              <br />
              ฿ {{amount.revenue| numFormat('0,0.00')}}
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>ค่าอาหาร</strong>
              <br />
              ฿ {{amount.food| numFormat('0,0.00')}}
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>ค่าจัดส่ง</strong>
              <br />
              ฿ {{amount.delivery| numFormat('0,0.00')}}
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>ส่วนลด</strong>
              <br />
              ฿ {{amount.discount| numFormat('0,0.00')}}
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>จำนวนบิล</strong>
              <br />
              {{(amount.completed/orderList.length)*100| numFormat('0,0')}}%
              <span>({{amount.completed}}/{{orderList.length}})</span>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>จำนวนสินค้า</strong>
              <br />
              {{amount.quantity| numFormat('0,0')}}
            </v-flex>
          </v-layout>
        </el-card>
      </v-flex>
      <v-flex xs12 sm3 md3 class="text-xs-right">
        <el-button
          icon="fas fa-plus"
          v-if="mode=='admin' || mode=='super_admin'"
          @click="onNewOrder()"
          type="danger"
          size="small"
        >&nbsp;สร้างออเดอร์ใหม่</el-button>
      </v-flex>
    </v-layout>

    <el-card class="mt-3">
      <v-data-table
        :headers="headers"
        :items="orderList"
        :pagination.sync="pagination"
        :loading="isLoading"
        class="elevation-0"
      >
        <template v-slot:no-data>
          <div class="text-xs-center">
            <img src="../../assets/img/no-order.png" style="width:30%;" />
          </div>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">
              <div>
                <span class="grey--text">{{props.item.order_reference}}-</span>
                {{props.item.order_id | numFormat('00000')}}
              </div>
              <div
                v-if="props.item.status=='cancelled'"
                class="grey lighten-2 badge-status centered"
              >ยกเลิกแล้ว</div>
              <div
                v-if="props.item.status=='pending'"
                class="grey lighten-2 badge-status centered"
              >รอชำระเงิน</div>
              <div v-else-if="props.item.status=='new'" class="red badge-status centered">มาใหม่</div>
              <div
                v-if="props.item.status=='accepted' || props.item.status=='captured'"
                class="amber darken-1 badge-status centered"
              >ยืนยันแล้ว</div>
              <div
                v-if="props.item.status=='processing'"
                class="blue darken-2 badge-status centered"
              >ส่งให้ร้านแล้ว</div>
              <div
                v-if="props.item.status=='cooking'"
                class="blue darken-4 badge-status centered"
              >กำลังทำอาหาร</div>
              <div
                v-if="props.item.status=='completed'"
                class="green lighten-1 badge-status centered"
              >เรียบร้อยแล้ว</div>
            </td>
            <td class="text-xs-left">
              <el-button type="text" size="small" @click="openItem(props.item)">ดูรายละเอียด</el-button>
            </td>
            <td class="text-xs-left">
              <!-- เวลารับอาหาร -->
              <div style="width:150px;">
                <div>{{props.item.datetime_received| moment("DD/MM/YY HH:mm")}}</div>
                <div v-if="props.item.cluster_id!=null">
                  <el-tag
                    v-if="props.item.shop.cluster_json.find(x=>x.id==props.item.cluster_id)"
                    size="mini"
                    type="info"
                  >รอบส่ง {{props.item.shop.cluster_json.find(x=>x.id==props.item.cluster_id).delivery}}</el-tag>
                </div>
                <div v-if="props.item.driver_info_json!=null">
                  <a
                    v-if="props.item.driver_info_json.orderRef"
                    :href="`https://share.lalamove.com/?TH`+props.item.driver_info_json.orderRef+`&lang=th_TH`"
                    target="_blank"
                  >
                    <img src="../../assets/img/lalamove.png" style="width:40%;" />
                  </a>
                </div>
              </div>
            </td>
            <td class="text-xs-left">
              <!-- ข้อมูลลูกค้า -->
              <div style="width:120px;">
                <template v-if="props.item.user_ref_json!=null">
                  {{props.item.user_ref_json.firstname}} {{props.item.user_ref_json.lastname}}
                  <br />
                  <span class="font-xs">
                    <i class="fas fa-mobile-alt"></i>
                    {{props.item.user_ref_json.mobile}}
                  </span>
                </template>
              </div>
            </td>
            <td class="text-xs-left">
              <!-- เส้นทาง -->
              <div style="width:220px; padding:10px 0;">
                <ul class="my-progress" v-if="props.item.order_type=='delivery'">
                  <li class="progress__item progress__item--completed">
                    <p class="progress__title">{{props.item.shop.name}}</p>
                  </li>
                  <li class="progress__item progress__item--active">
                    <p class="progress__title">
                      <span
                        v-if="props.item.delivery_info_json.whereTo.address.text"
                      >{{props.item.delivery_info_json.whereTo.address.text}}</span>
                      <span v-else>{{props.item.delivery_info_json.whereTo.address}}</span>
                      <span
                        v-if="props.item.distance!=null && props.item.distance!=-1"
                        class="font-xs black--text text-xs-left"
                      >(ระยะทาง {{props.item.distance/1000 | numFormat('0.00')}} km)</span>
                    </p>
                  </li>
                </ul>
                <ul class="my-progress" v-if="props.item.order_type=='pickup'">
                  <li class="progress__item progress__item--completed">
                    <p class="progress__title">รับอาหารที่ร้าน {{props.item.shop.name}}</p>
                  </li>
                </ul>
                <!--
                <ul class="routes" v-if="props.item.order_type=='delivery'">
                  <li>{{props.item.shop.name}}</li>
                  <li>
                    <span
                      v-if="props.item.delivery_info_json.whereTo.address.text"
                    >{{props.item.delivery_info_json.whereTo.address.text}}</span>
                    <span v-else>{{props.item.delivery_info_json.whereTo.address}}</span>
                  </li>
                </ul>
                <div v-if="props.item.order_type=='pickup'">
                  <i class="fas fa-shopping-bag"></i>
                  รับอาหารที่ร้าน {{props.item.shop.name}}
                </div>
                -->
              </div>
            </td>
            <!-- จำนวนเงิน-->
            <td class="text-xs-left">
              <template>
                <strong>฿ {{props.item.amount.total | numFormat('0,0.00')}}</strong>
                <br />

                <span class="font-xs grey--text" v-if="props.item.payment_type=='transfer'">
                  โอนเงิน
                  <i
                    v-if="props.item.payment.payment_image_url!=null"
                    @click="viewSlip(props.item.payment.payment_image_url)"
                    class="far fa-file-image"
                  ></i>
                </span>
                <span class="font-xs grey--text" v-if="props.item.payment_type=='cash'">ชำระเงินสด</span>
                <span
                  class="font-xs grey--text"
                  v-if="props.item.payment_type=='creditcard'"
                >บัตรเครดิต</span>
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </el-card>
  </v-container>
</template>

<script>
import Service from "../../services";
import moment from "moment";

import { mapState } from "vuex";

export default {
  data() {
    return {
      mode: "admin",
      isLoading: false,
      date: "",
      orderList: [],
      refresh: null,
      amount: {
        revenue: 0,
        delivery: 0,
        food: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0
      },
      pagination: {
        rowsPerPage: -1
      },
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: ""
        },
        { text: "", value: "", sortable: false },
        { text: "เวลารับอาหาร", value: "", sortable: false },
        { text: "ข้อมูลลูกค้า", value: "", sortable: false },
        { text: "เส้นทาง", value: "", sortable: false },
        { text: "จำนวนเงิน", value: "", sortable: false }
      ],
      statusOrder: [
        "pending",
        "new",
        "acccepted",
        "cooking",
        "processing",
        "completed",
        "cancelled"
      ],
      permission: null,
      paymentSlip: null
    };
  },
  created() {
    Service.User.permission().then(resp => {
      this.permission = resp.data;
      this.mode = this.permission.user.role_id;
    });
    this.date = moment().format("LLLL");

    this.loadOrder();
    /*
    this.refresh = setInterval(() => {
      this.loadOrder();
    }, 30000);
    */
  },
  methods: {
    loadOrder() {
      this.isLoading = true;
      this.amount = {
        revenue: 0,
        delivery: 0,
        food: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        discount: 0,
        completed: 0
      };

      console.log();
      let params = {
        begin: moment()
          .add(1, "days")
          .format("YYYY-MM-DD"),
        end: moment()
          .add(7, "days")
          .format("YYYY-MM-DD"),
        type: "view"
      };

      var queryString = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");

      Service.Order.gets(queryString).then(res => {
        this.isLoading = false;
        if (res.success) {
          this.orderList = res.data;

          this.orderList.sort(
            (a, b) =>
              this.statusOrder.indexOf(a.status) -
              this.statusOrder.indexOf(b.status)
          );

          this.orderList.map(item => {
            if (item.status == "completed") {
              this.amount.revenue += parseFloat(item.amount.total);
              this.amount.delivery += parseFloat(item.amount.delivery);
              this.amount.food += parseFloat(item.amount.food);
              this.amount.extra += parseFloat(item.amount.extra);
              this.amount.discount += parseFloat(item.amount.discount);
              this.amount.completed++;

              let cog = 0;
              item.order_basket.product_list.map(product => {
                cog += parseInt(product.cog) * product.quantity;
                this.amount.quantity += product.quantity;
              });
              item.amount.cog = cog;
              this.amount.cog += item.amount.cog;
            }
          });
        }
      });
    },
    onNewOrder() {
      if (this.mode == "enterprise_manager") {
        let ent_id = this.permission.user.permission_json
          .included_enterprises[0];
        this.$router.push("/create/order?ent_id=" + ent_id);
      } else {
        this.$router.push("/create/order");
      }
    },
    openItem(item) {
      this.$router.push("/view/order/" + item.order_reference);
    },
    viewSlip(url) {
      this.paymentSlip = url;
    }
  },
  beforeRouteLeave(to, from, next) {
    //this.$store.dispatch("Auth/setWorkState", "working");
    //clearInterval(this.refresh);
    next();
  }
};
</script>
<style>
tbody tr:nth-of-type(even) {
  background-color: rgb(241, 241, 241);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}

.v-data-table-header {
  background-color: rgba(182, 183, 187);
  color: white;
}

.v-data-footer {
  background-color: rgb(250, 250, 250);
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>


